import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ProfessionalCovenants from "src/Professional/ProfessionalCovenants";
import ProfessionalName from "src/Professional/ProfessionalName";
import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import { cardBase, cardHeader } from "src/shared/styles/cardStyles";
import {
  capitalizeWord,
  serializeDateFormatLong,
} from "src/shared/global/helpers";
import { useSetRecoilState } from "recoil";
import {
  reservationForCancelSelectedState,
  showModalCancelReservationState,
} from "../state/atoms";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

const ChildrenHeaderCard = ({ horas, sede }) => {
  return (
    <>
      {/* <Typography
                style={{
                    fontWeight: 600,
                    fontSize: 12,
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}
            >
                <CalendarTodayIcon
                    style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginRight: 10,
                    }}
                />{" "}
                {horas[0]?.ageInicio} / {capitalizeWord(serializeDateFormatLong(horas[0]?.ageFecha, true))}
            </Typography> */}
      {/* <div
        style={{
          fontSize: 12,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography
            style={{
              fontWeight: 600,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <CalendarTodayIcon
              style={{
                fontWeight: 600,
                fontSize: 12,
                marginRight: 10,
              }}
            />{" "}
            {horas[0]?.ageInicio} /{" "}
            {capitalizeWord(serializeDateFormatLong(horas[0]?.ageFecha, true))}
          </Typography>
        </div>
        <div>
          <small>Sucursal: </small>
          <strong style={{textShadow: '1px 1px 1px #666666'}}>{sede}</strong>
        </div>
      </div> */}

      { process.env.REACT_APP_SEDE == 'Calama' || process.env.REACT_APP_SEDE == 'Chillán'   ? (<Typography
                style={{
                    fontWeight: 600,
                    fontSize: 12,
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}
            >
                <CalendarTodayIcon
                    style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginRight: 10,
                    }}
                />{" "}
                {horas[0]?.ageInicio} / {capitalizeWord(serializeDateFormatLong(horas[0]?.ageFecha, true))}
            </Typography> ) : (      <div
        style={{
          fontSize: 12,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography
            style={{
              fontWeight: 600,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <CalendarTodayIcon
              style={{
                fontWeight: 600,
                fontSize: 12,
                marginRight: 10,
              }}
            />{" "}
            {horas[0]?.ageInicio} /{" "}
            {capitalizeWord(serializeDateFormatLong(horas[0]?.ageFecha, true))}
          </Typography>
        </div>
        <div>
          <small>Sucursal: </small>
          <strong style={{textShadow: '1px 1px 1px #666666'}}>{sede}</strong>
        </div>
      </div>) }

    </>
  );
};

const CardReservation = ({ professional, cancelReservation = true }) => {
  const theme = useTheme();
  const isMediaScreen = useMediaQuery(theme.breakpoints.up("md"));

  const setShowModalCancelReservation = useSetRecoilState(
    showModalCancelReservationState
  );
  const setReservationForCancelSelected = useSetRecoilState(
    reservationForCancelSelectedState
  );

  const handleOpenModal = () => {
    setShowModalCancelReservation(true);
    setReservationForCancelSelected(professional);
  };

  return (
    <Card sx={{ ...cardBase }}>
      <CardHeader
        style={{ ...cardHeader }}
        title={
          <ChildrenHeaderCard
            horas={professional.horas}
            sede={professional.sede}
          />
        }
      />
      <CardContent style={{ backgroundColor: "#F9FAFB" }}>
        <Grid
          style={{
            display: "flex",
            alignItems: !isMediaScreen ? "flex-start" : "center",
          }}
        >
          <ProfessionalPhoto
            image={professional.imagen}
            alt={professional.ptdNombre}
            rut={professional.ptdRut}
          />

          <Grid item md={12} ml={2}>
            <Grid item md={12}>
              <ProfessionalName nameProfessional={professional.ptdNombre} />
              <ProfessionalSpecialities
                specialities={professional.especialidades}
              />
            </Grid>

            <Grid container spacing={1} mt={2}>
              <Grid item xs={12} md={3}>
                <Typography style={{ fontWeight: "bold", fontSize: 12 }}>
                  Valor particular:
                </Typography>

                <Typography style={{ fontWeight: 500, fontSize: 12 }}>
                  {professional?.valorParticular?.replace(",", ".") ||
                    "No especificado"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={9} mt={!isMediaScreen ? 2 : 0}>
                <ProfessionalCovenants covenants={professional.convenios} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      {cancelReservation && (
        <CardActions style={{ padding: 16 }}>
          <Link
            style={{
              textDecoration: "none",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "18px",
            }}
            component="button"
            variant="body2"
            color="error"
            onClick={handleOpenModal}
          >
            Anular reserva
          </Link>
        </CardActions>
      )}
    </Card>
  );
};

export default CardReservation;
